import React from "react";

import {UserService} from "../../serverService/userService/UserService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect, useState} from "react";
import {
    RaikoAlert, raikoAlertTypes,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoConfirmDialog,
    RaikoSectionContainer,
    RaikoToggleOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function UserBanAccess({userId}) {


    const service = new UserService();
    const loading = new LoadingHelper(useLoadingDispatcher());

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getUserEnabled()
        }
    }, [userId])

    const [confirmDialogOpenState, setConfirmDialogOpenState] = useState(false)
    const [enabled, setEnabled] = useState(true)

    function handleCloseConfirmDialog() {
        setConfirmDialogOpenState(false)
    }

    function handleOpenConfirmDialog() {
        setConfirmDialogOpenState(true)
    }


    function getUserEnabled() {
        loading.show()
        service.getUserEnabled(userId).then(
            response => {
                setEnabled(response.enabled)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    function handleChangeEnableSetting() {
        loading.show()

        service.updateUserEnabled(
            userId,
            !enabled
        ).then(response => {

            if (response.enabled)
                showSuccessMessage("دسترسی کاربر با موفقیت فعال شد.")
            else
                showWarningMessage("دسترسی کاربر با موفقیت مسدود شد.")

            setConfirmDialogOpenState(false)
            setEnabled(response.enabled)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    return (
        <>
            <RaikoConfirmDialog
                openConfirmDialog={confirmDialogOpenState}
                cancelAction={handleCloseConfirmDialog}
                doAction={handleChangeEnableSetting}

                pageTitle={"مسدود سازی کاربر"}
                warningTitle={"آیا از تغییر وضعیت این مورد اطمینان دارید؟"}
                warningDescription={""}
                confirmButtonTitle={!enabled ? "رفع مسدود سازی" : "مسدود سازی"}
            />
            <RaikoBaseContainer>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"وضعیت مسدود سازی کاربر"}
                    >
                        <RaikoAlert
                            type={raikoAlertTypes.error}
                            title={"وضعیت مسدود سازی کاربر"}
                            description={[
                                "* با فعالسازی این مورد کاربر مسدود خواهند بود و در غیر این صورت تور تنها به عنوان پیش نویس در پنل مدیریت باقی خواهند ماند.",
                                "در صورت غیر فعال بودن این مورد هیچ کدام از دوره های زمانی ساخته شده برای این تور نیز غیرفعال خواهند بود و به نمایش در نخواهند آمد.",
                                "",
                            ]}
                        />
                        <RaikoToggleOutlined
                            labelText={"مسدود سازی (مسدود شده / رفع مسدود سازی)"}
                            setChecked={state => {
                                handleOpenConfirmDialog()
                            }}
                            checked={!enabled}
                        />
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}